module.exports = __webpack_public_path__ + "static/img/yinxiang.630d183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/yinxiang.png
// module id = aKcP
// module chunks = 12